import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutoForwardRule, AutoForwardSpoke } from '../../../models/auto-forwarding.model';
import { AutoForwardingService } from '../../../services/auto-forwarding.service';

export interface ConfigureAutoForwardDialogData {
  caseName: string;
  hubFacilityId: string;
  existingRule: AutoForwardRule | null;
}

@Component({
  selector: 'app-configure-auto-forward-dialog',
  templateUrl: './configure-auto-forward-dialog.component.html',
  styleUrls: ['./configure-auto-forward-dialog.component.scss'],
  standalone: false,
})
export class ConfigureAutoForwardDialogComponent implements OnInit {
  spokes: AutoForwardSpoke[] = [];
  selectedSpokeId = '';
  loadingSpokes = true;
  saving = false;
  error = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfigureAutoForwardDialogData,
    private dialogRef: MatDialogRef<ConfigureAutoForwardDialogComponent>,
    private autoForwardingService: AutoForwardingService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      this.spokes = await this.autoForwardingService.getSpokesWithAeTitle(this.data.hubFacilityId);
      if (this.data.existingRule?.destinationSpokeId) {
        this.selectedSpokeId = this.data.existingRule.destinationSpokeId;
      }
    } catch (err) {
      this.error = 'Failed to load facilities. Please try again.';
    } finally {
      this.loadingSpokes = false;
    }
  }

  async onSave(): Promise<void> {
    if (!this.selectedSpokeId || this.saving) return;
    this.saving = true;
    this.error = '';
    try {
      await this.autoForwardingService.upsertRule(
        this.data.hubFacilityId,
        this.data.caseName,
        this.selectedSpokeId,
        true
      );
      this.dialogRef.close(true);
    } catch (err: any) {
      this.error = err?.message || 'Failed to save rule. Please try again.';
    } finally {
      this.saving = false;
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
